<!--
<template>
  <el-card>
    <h1>estoy en el componente</h1>
    <Pie :chart-data="chartData1" :chart-options="ChartOptions1" />
  </el-card>
</template>
-->

<script>
import { Pie } from "vue-chartjs";

export default {
  extends: Pie,
  props: {
    chartDataProp: {
      type: Object,
      default: () => {}
    },
    chartOptionsProp: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      chartData: this.chartDataProp,
      /*{
        labels: ["Italy", "India", "Japan", "USA",],
        datasets: [{
            borderWidth: 1,
            
            borderColor: [
            'rgba(255,99,132,1)',
            'rgba(54, 162, 235, 1)',
            'rgba(255, 206, 86, 1)',
            'rgba(75, 192, 192, 1)'            
            ],
            
            backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(255, 206, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)',                
            ],
            
            data: [1000,	500,	1500,	1000]
          }]
      },*/
      options: this.chartOptionsProp
      /*{
        legend: {
          display: true
        },
        responsive: true,
        maintainAspectRatio: false
      }
      */
    };
  },
  mounted() {
    //this.renderChart(this.chartData, this.options)
  },
  methods: {
    RerenderChart(chartData, options) {
      // console.log("renderChart: \nchartData:", chartData,"\noptions", options)
      this.renderChart(chartData, options);
    }
  }
};
</script>
<!--
<script>
import { Pie } from  "vue-chartjs" /* "vue-chartjs/legacy" */;
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

export default {
  name: "PolarAreaChart",
  components: {
    Pie
  },
  props: {
    chartData: {
      type: Object,
      //required: true,
      default: () => {}
    },
    chartOptions: {
      type: Object,
      //required: true,
      default: () => {}
    }
  },
  data() {
    return {
      chartData1: {
        labels: ["VueJs", "EmberJs", "ReactJs", "AngularJs"],
        datasets: [40, 20, 80, 10]
      },
      ChartOptions1: {
        responsive: true
      }
    };
  }
};
</script>
-->
<style scoped></style>
